export enum FormTypeEnum {
    Add = 1,
    Edit = 2,
    Scan = 3
}
